<template>
  <div class="xcard">
    <h3 class="text-center text-primary">Registro de docentes</h3>
    <p class="text-center">Complete el siguiente formulario con los datos del docente para registralo en el sistema portal.</p>
    <a-reg-docentes></a-reg-docentes>
  </div>
</template>

<script>
import ARegDocentes from '@/components/ARegDocentes.vue';
export default {
  components: { ARegDocentes },
};
</script>